//获取公司成员信息
import { getUserListByCompanyIdAPI } from '@/apis/user'
import { useState, useEffect } from 'react'

function useUserListCompany(companyId) {
    const [userList, setUserList] = useState([])

    useEffect(() => {
        const getCompanyList = async () => {
            const res = await getUserListByCompanyIdAPI(companyId)
            setUserList(res.data)
        }
        getCompanyList()
    }, [companyId])
    return {
        userList
    }
}

export { useUserListCompany } 